import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const DEFAULT_LANG = 'en'
const LOCALE_KEY = 'localeLanguage'

const locales = {
  ar: require('./ar.json'),
  de: require('./de.json'),
  en: require('./en.json'),
  es: require('./es.json'),
  fr: require('./fr.json'),
  id: require('./id.json'),
  it: require('./it.json'),
  ja: require('./ja.json'),
  "pt-BR": require('./pt-BR.json'),
  ru: require('./ru.json'),
  th: require('./th.json'),
  "zh-Hans": require('./zh-Hans.json'),
  "zh-Hant": require('./zh-Hant.json'),
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales,
})

export const setup = lang => {
  if (lang === undefined) {
    lang = window.localStorage.getItem(LOCALE_KEY)
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  window.localStorage.setItem(LOCALE_KEY, lang)

  Object.keys(locales).forEach(lang => {
    document.body.classList.remove(`lang-${lang}`)
  })
  document.body.classList.add(`lang-${lang}`)
  document.body.setAttribute('lang', lang)

  i18n.locale = lang
}

setup()
export default i18n